import APIService from '../api';

class TransactionsService extends APIService {
  get resource() {
    return `/admin`;
  }
  getTransactions(
    sortField: string = '',
    sortOrder: string = '',
    pagination: string = '',
    filters: string
  ) {
    const resource = this.generateResource(
      `${this.resource}/transaction/offer-transactions?`,
      sortField,
      sortOrder,
      pagination,
      filters
    );
    return this.get(resource);
  }

  getCoupons(sortField = '', sortOrder = '', pagination = '', filters: string) {
    const resource = this.generateResource(
      `${this.resource}/coupon?`,
      sortField,
      sortOrder,
      pagination,
      filters
    );
    return this.get(resource);
  }

  getRewardedCoins(
    sortField: string = '',
    sortOrder: string = '',
    pagination: string = '',
    filters: string
  ) {
    const resource = this.generateResource(
      `${this.resource}/transaction/rewarded-coins?`,
      sortField,
      sortOrder,
      pagination,
      filters
    );
    return this.get(resource);
  }

  getPurchasedCoins(
    sortField: string = '',
    sortOrder: string = '',
    pagination: string = '',
    filters: string
  ) {
    const resource = this.generateResource(
      `${this.resource}/transaction/purchased-coins?`,
      sortField,
      sortOrder,
      pagination,
      filters
    );
    return this.get(resource);
  }
}

export default TransactionsService;
